module.exports = __webpack_public_path__ + "img/icon2.ea0fbb13.svg";